module.exports = __webpack_public_path__ + "static/snake_tree_leafs_albedo-0a11f87b3cc29b335fc94ff55808375e.png";